import { Instance } from 'js/components/YextAnalytics/Analytics.js';
import { TooltipHandler } from './TooltipHandler';
import { Scope } from './Scope';

export class ScopeNameTab {
  constructor () {
    this.title = document.createElement('h2');
    this.title.innerText = 'Scope Names';
    this.title.classList.add('Analytics-tabs--title');

    this.searchInput = document.createElement('input');
    this.searchInput.setAttribute('placeholder', 'Type to search event scopes...');
    this.searchInput.classList.add('Analytics-tabs--search');
    this.searchInput.classList.add('no-tooltip');
    this.searchInput.addEventListener('keyup', (evt) => {
      const target = evt.target;
      const value = target.value;
      const items = document.querySelectorAll('.Analytics-tabs--item.active .Analytics-list--item');
      const hiddenFilter = Array.from(items).filter(
        (item) => item.innerText.indexOf(value) == -1
      );
      hiddenFilter.forEach(
        (element) => element.style['display'] = 'none'
      );
      const visibleFilter = Array.from(items).filter(
        (item) => item.innerText.indexOf(value) > -1
      );
      visibleFilter.forEach(
        (element) => element.style['display'] = 'block'
      );
    });

    this.footerToggle = document.createElement('button');
    this.footerToggle.classList.add('Analytics-tabs--footerToggle');
    this.footerToggle.classList.add('no-tooltip');
    this.footerToggle.innerText = '[Beta] Toggle All Tooltips';
    this.footerToggle.addEventListener('click', (evt) => {
      document.querySelectorAll('.Highlight').forEach(
        (element) => element.classList.remove('Highlight')
      );
      this.removeTooltips();
      this.footerToggle.classList.toggle('active');
      if (this.footerToggle.classList.contains('active')) {
        this.applyOnScopeElements((scopeName) => {
          this.addScopeTooltips(scopeName);
        });
      }
    });
    this.dataList = this.makeList();
    this.siblings = [
      this.title,
      this.searchInput,
      this.dataList,
      this.footerToggle
    ];
    this.updateList();
    new MutationObserver(() => this.updateList())
      .observe(document.body, { childList: true, subtree: true });
  }

  applyOnScopeElements(callback = () => {}) {
    const scopes = document.querySelectorAll('[data-ya-scope]:not([data-ya-scope-debug])');
    scopes.forEach((scope) => {
      callback(scope.getAttribute('data-ya-scope'));
      scope.setAttribute('data-ya-scope-debug', '');
    });
  }

  makeList() {
    let dataList = document.createElement('ul');
    dataList.classList.add('Analytics-list');
    return dataList;
  }

  makeItem(scopeName) {
    const activeClass = 'EventNameTab-button--active';

    let dataItem = document.createElement('li');
    dataItem.classList.add('Analytics-list--item');
    dataItem.setAttribute('data-scope-name', scopeName);
    let itemButton = document.createElement('button');
    itemButton.classList.add('EventNameTab-button');
    itemButton.classList.add('no-tooltip');
    itemButton.innerText = scopeName;
    itemButton.addEventListener('click', (evt) => {
      this.removeTooltips();
      document.querySelectorAll('.Highlight').forEach(
        element => element.classList.remove('Highlight')
      );
      document.querySelectorAll(`.${activeClass}`).forEach(
        element => element.classList.remove(activeClass)
      );
      itemButton.classList.add(activeClass);
      this.addScopeTooltips(scopeName);
    });
    dataItem.appendChild(itemButton);
    return dataItem;
  }

  clearList() {
    this.dataList.innerHTML = '';
  }

  addScope(scopeName) {
    const element = document.querySelector(`[data-ya-scope="${scopeName}"]`);
    const scope = new Scope(scopeName);
    scope.appendTo(document.body);
    scope.position(
      (window.pageYOffset + element.getBoundingClientRect().top) + 'px',
      (element.getBoundingClientRect().right - scope.getWidth()) + 'px',
      'auto',
      'auto'
    );
  }

  addScopeTooltips(scopeName) {
    const element = document.querySelector(`[data-ya-scope="${scopeName}"]`);
    const taggedItems = element.querySelectorAll('a, input, button');
    taggedItems.forEach((taggedItem) => {
      TooltipHandler.add(
        Instance.CalcEventNameForElement(taggedItem),
        taggedItem
      );
    });
  }

  removeTooltips() {
    TooltipHandler.removeAll();
  }

  getTemplate() {
    let tab = document.createElement('div');
    tab.classList.add('Analytics-tabs--item');
    this.siblings.forEach(sibling => tab.appendChild(sibling));
    return tab;
  }

  getButton() {
    let button = document.createElement('button');
    button.classList.add('Analytics-toggles--item');
    button.classList.add('no-tooltip');
    button.innerText = 'Scopes';
    return button;
  }

  loadData() {
    const scopes = Array.from(
      document.querySelectorAll('[data-ya-scope]:not([data-ya-scope-debug])')
    );
    for (const scope of scopes) {
      const scopeName = scope.getAttribute('data-ya-scope');
      const nextChild = Array.from(this.dataList.children)
        .find(el => el.getAttribute('data-scope-name') > scopeName) || null;
      this.dataList.insertBefore(
        this.makeItem(scopeName),
        nextChild
      );
    }
  }

  updateList() {
    this.loadData();
    this.applyOnScopeElements((scopeName) => {
      this.addScope(scopeName);
    });
  }
}
